import * as React from "react";
import { Header } from "src/component/shared/layout/header/Header";
import { Navigation } from "src/component/shared/layout/navigation/Navigation";
import { Footer } from "src/component/shared/layout/footer/Footer";
import { DashBoard } from "../products/Dashboard";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import "./Main.scss";

// tslint:disable-next-line:no-empty-interface
export interface IMainProps {}

// tslint:disable-next-line:no-empty-interface
export interface IMainState {}

export class Main extends React.Component<IMainProps, IMainState> {
  constructor(props: IMainProps) {
    super(props);
  }

  public render() {
    return (
      <div className="main-page">
        <Header title={"Portal Bookinfo"} name={"Produtos"} link={"/dashboard"} />

        <Navigation name={"Portal Bookinfo"}
            linkDefault={"/dashboard"}
            link={"/dashboard"}
            linkTitle={"Portal Bookinfo"}
            painel={0}
            icon={<ChevronRightIcon />}
        />

        <div className="main-dashboard">
          <DashBoard />
        </div>
        <div className="main-footer">
          <Footer />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/main/Main.tsx